module.exports = __webpack_public_path__ + "static/media/ca.e5980c41.svg";